<script lang="ts" setup>
  import { Toaster } from '~/components/ui/sonner'
  import InactivityMonitor from '~/components/auth/InactivityMonitor.vue'
  import MiniStepLoader from '~/components/ui/mini-step-loader/MiniStepLoader.vue'
  import 'vue-sonner/style.css'
  import LocalizationWatcher from '~/components/watchers/LocalizationWatcher.vue'

  // Uncomment if you need TanStack Query DevTools:
  // import { useQueryClient } from '@tanstack/vue-query'
  // if (import.meta.dev) {
  //   window.__TANSTACK_QUERY_CLIENT__ = useQueryClient()
  // }

  const authStore = useAuthStore()

  const loadSiteReach = async (): Promise<void> => {
    try {
      await authStore.loadSiteReach()
    } catch (error) {
      console.error('[App] Failed to load site reach on mount:', error)

      authStore.setActiveSite(undefined)
    }
  }

  onMounted(async () => {
    if (authStore.activeLicence && !authStore.permissionsLoaded) {
      try {
        await authStore.loadPermissions()
      } catch (error) {
        console.error('[App] Failed to load permissions on mount:', error)

        authStore.clearActiveLicence()
      }
    }

    if (authStore.activeLicence) {
      await loadSiteReach()
    }
  })

  watch(
    () => authStore.activeLicence?.id,
    async (licenceId) => {
      if (licenceId && !authStore.siteReachLoaded) {
        await loadSiteReach()
      }
    }
  )
</script>

<template>
  <ThemeProvider>
    <LocalizationWatcher />
    <NuxtLoadingIndicator />
    <InactivityMonitor />
    <NuxtPage />
    <Toaster rich-colors />
    <MiniStepLoader />
  </ThemeProvider>
</template>
